module.exports = __webpack_public_path__ + "media/images/emblems/Zielebach-coat_of_arms-fe1cdf3ece4aaecb478b843b360d4b68.svg";